export const decodeJWT = (token) => {
    try {
        const base64Url = token.split(".")[1];
        if (!base64Url)
            return null;
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(atob(base64)
            .split("")
            .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
            .join(""));
        return JSON.parse(jsonPayload);
    }
    catch (error) {
        console.error("Failed to decode JWT:", error);
        return null;
    }
};
export const isTokenExpired = (token) => {
    const decoded = decodeJWT(token);
    if (!decoded)
        return true;
    const currentTime = Date.now() / 1000;
    return decoded.exp < currentTime;
};
export const getPermissionsFromToken = (token) => {
    const decoded = decodeJWT(token);
    return (decoded === null || decoded === void 0 ? void 0 : decoded.permission) || [];
};
export const getUserInfoFromToken = (token) => {
    const decoded = decodeJWT(token);
    if (!decoded)
        return null;
    // Normalize roles to array
    const roles = Array.isArray(decoded.role)
        ? decoded.role
        : decoded.role
            ? [decoded.role]
            : [];
    // Ensure permissions is an array
    const permissions = Array.isArray(decoded.permission)
        ? decoded.permission
        : [];
    return {
        sub: decoded.sub,
        email: decoded.email,
        userName: decoded.userName,
        tenantId: decoded.tenantId,
        firstName: decoded.firstName,
        lastName: decoded.lastName,
        userId: decoded.userId,
        roleId: decoded.roleId,
        role: roles, // Return as array for consistency
        permission: permissions,
    };
};
